import { CustomDetailsList } from "../../../common/customDetailsList/customDetailsList";
import { Skeleton } from "../../../common/skeleton/skeleton";
import { ApointmentHistoricListColumn } from "./column/column";
import { SkeletonSizes } from "../../../../common/constants";
import { IAppointmentHistoricList } from "../../../../models/appointment/IAppointmentHistoric";

interface IAppointmentHistoricListContainer {
    list?: IAppointmentHistoricList[];
    loading: boolean;
    selectedKey: string;
}

export const AppointmentHistoricList: React.FC<IAppointmentHistoricListContainer> = ({ list, loading, selectedKey }) => {
    const renderColumns = () => {
        return ApointmentHistoricListColumn(selectedKey);
    };

    return loading ? (
        <Skeleton rows={SkeletonSizes.DEFAULT} />
    ) : (
        <CustomDetailsList
            data={list ?? []}
            renderColumns={renderColumns}
            height="calc(100vh - 20.0rem)"
        />
    );
};
